import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: 'toggle'
        }
    }

    init() {

    }

    /**
     * toggle
     *
     * @param
     */
    toggle() {
        this.call('toggle', null, 'Menu')
    }
}
